import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import { Auth, useAuth } from './units/auth/AuthProvider';
import LoginPage from './pages/login-page/LoginPage';
import { ProfilePage } from './pages/profile-page/ProfilePage';
import { HomePage } from './pages/home-page/HomePage';
import { UserManagePage } from './pages/user-manage-page/UserManagePage';
import { UserGroupManagePage } from './pages/user-group-manage-page/UserGroupManagePage';
import { NoMatchPage } from './pages/no-match-page/NoMatchPage';
import { PageManagePage } from './pages/page-manage-page/PageManagePage';
import { MenuManagePage } from './pages/menu-manage-page/MenuManagePage';
import { EnumPage, EnumPageMap } from './data/PageMap';
import { useGlobal } from './units/global/GlobalProvider';
import { PageConfig } from './api/page-config';
import { CarManagePage } from './pages/car-manage-page/CarManagePage';
import { CarQueueManagePage } from './pages/car-queue-manage-page/CarQueueManagePage';
import moment from 'moment';
import 'moment/locale/zh-tw';
import { CarQueueDashboardPage } from './pages/car-queue-dashboard-page/CarQueueDashboardPage';
import { PriceListPage } from './pages/price-list-page/PriceListPage';
import { SimpleReservationPage } from './pages/simple-reservation-page/SimpleReservationPage';
import { LineMenuPage } from './pages/line-menu-page/lineMenuPage';
import { StoreManagePage } from './pages/store-manage-page/StoreManagePage';
import { ClosedManagePage } from './pages/closed-manage-page/ClosedManagePage';

const DynamicPage = (props: { enumPage: EnumPage }) => {
    switch (props.enumPage) {
        case EnumPage.UserManage:
            return <UserManagePage />;
        case EnumPage.UserGroupManage:
            return <UserGroupManagePage />;
        case EnumPage.PageManage:
            return <PageManagePage />;
        case EnumPage.MenuManage:
            return <MenuManagePage />;
        case EnumPage.CarManage:
            return <CarManagePage />;
        case EnumPage.CarQueueManage:
            return <CarQueueManagePage />;
        case EnumPage.Closed:
            return <ClosedManagePage />;
        case EnumPage.StoreManage:
            return <StoreManagePage />;
        default:
            return <NoMatchPage />;
    }
};

moment.locale('zh-tw');

function App() {
    const auth = useAuth();
    const global = useGlobal();
    const [pageConfigs, setPageConfigs] = useState<PageConfig[]>([]);

    useEffect(() => {
        const newPageConfigs = global.userGroups
            .filter((userGroup) => (userGroup.users || []).map((v) => v.userId).includes(auth.profile.userId))
            .map((userGroup) => userGroup.pageConfigs || [])
            .flat(1)
            .filter((v, i, a) => a.findIndex((s) => v.pageConfigId === s.pageConfigId) === i);
        setPageConfigs(newPageConfigs);
    }, [global.userGroups]);

    return (
        <div className='App'>
            <Routes>
                <Route path='/' element={<LoginPage />} />
                <Route path='/login' element={<LoginPage />} />
                <Route path={'/home'} element={auth.isAuth ? <HomePage /> : <LoginPage />} />
                <Route path={'/profile'} element={auth.isAuth ? <ProfilePage /> : <LoginPage />} />
                {/* <Route path={'/reservation'} element={auth.isAuth ? <ReservationPage /> : <LoginPage />} /> */}
                <Route path={'/simple-reservation'} element={auth.isAuth ? <SimpleReservationPage /> : <LoginPage />} />
                <Route path={'/car-queue-dashboard'} element={<CarQueueDashboardPage />} />
                <Route path={'/price-list'} element={<PriceListPage />} />
                <Route path={'/line-menu'} element={<LineMenuPage />} />
                {pageConfigs.map((pageConfig) => (
                    <Route
                        key={pageConfig.pageConfigId}
                        path={pageConfig.path}
                        element={
                            auth.isAuth ? <DynamicPage enumPage={EnumPageMap[pageConfig.componentName as EnumPage]?.key} /> : <LoginPage />
                        }
                    />
                ))}
                <Route path='/*' element={<NoMatchPage />} />
            </Routes>
        </div>
    );
}

export default App;
